






































import {Component, Vue} from 'vue-property-decorator';
import ILoginForm from '@/types/ILoginForm';
import {email, required} from '@/utils/validationRules';
import AuthService from '@/services/AuthService';
import UserService from '@/services/UserService';
import {resolveError} from '@/utils/notifications';

// const user = namespace('User')

@Component({name: 'LoginForm'})
export default class LoginForm extends Vue {
  form: ILoginForm = {
    username: '',
    password: ''
  }
  rules: object = {
    username: [required, email],
    password: [required]
  }
  loading: boolean = false

  // @user.Mutation
  // setUser!: (user: IUserInfo) => void

  async submit() {
    // @ts-ignore
    if (this.$refs.form.validate()) {
      this.loading = true
      try {
        await AuthService.login(this.form)
        // await this.setUser(user)
        await this.$router.push({name: 'Home'})
      } catch (e) {
        resolveError(e, 'login')
      } finally {
        this.loading = false
      }
    }
  }
}
